import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  display: block;
  z-index: 3;
  width: auto;
  width: 275px;
  position: relative;
  margin: auto;

  ${media.moreThan('sm')`    
    width:300px
  `};

  ${media.moreThan('smPlus')`
    position: absolute;
    margin-top:-220px;
    right: 0;
    width:400px
  `};

  ${media.moreThan('lg')`    
    margin-top:-250px;
    width:500px
  `};
`;
